// Copyright (c) 2017 Deere & Company

import '../../shared/styles/index.scss';
import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    bindOnConfirmActions,
    confirmationModalMap
} from '../services/confirmation-modal-map';
import ActionLink from '../../../shared/components/action-link';
import AttachmentClaim from '@deere/cps-it.warranty-model-factory/lib/claim-attachment';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import ClaimDetails from './claim-details-section';
import ClaimStickyHeader from '../../shared/components/claim-sticky-header';
import ClaimValue from '../../shared/components/claim-value';
import ClaimValueSummary from '../../shared/components/claim-value-summary/';
import ConfirmationModal from '../../../shared/components/confirmation-modal';
import ConfirmationModalState from '../../shared/state/confirmation-modal';
import CreateClaimModal from '../../../shared/components/create-claim-modal';
import CreateClaimModalType from '../../../shared/state/create-claim-modal';
import FailurePanel from './failure-panel';
import FileAttachmentPanel from '../../../shared/components/file-attachment-panel';
import LabeledNode from '../../../shared/components/labeled-node';
import LabeledString from '../../../shared/components/labeled-string';
import LaborsPanel from './labors-panel';
import OtherCreditsPanel from './other-credits-panel';
import PartsPanel from '../../shared/components/parts-panel';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import WarrantyStickyNode from '../../../shared/components/warranty-sticky-node';
import {buildDate} from '../../../shared/services/build-date';
import {formatClaimNumber} from '../../../shared/services/format-claim-number';
import {generateTemporaryObjectKey} from '../../../shared/services/generate-temporary-object-key';
import {getTempAttachmentServiceConfig} from '../../shared/services/claim-shared-helper';
import {translate} from '../../../shared/services/translation-service';

function handleFileDelete(file) {

    this.actions.deleteFile(file);

}

function handleFileUploadSuccess(file, dropzone) {

    const fileObject = JSON.parse(file.xhr.response);

    this.actions.addFile(fileObject);
    dropzone.removeFile(file);

}

function handleActionClick(action) {

    const onConfirmActions = bindOnConfirmActions(action, this.claim, {
        addRep: this.actions.additionalRepair,
        adjust: this.actions.updateSelectedAction,
        copy: this.actions.copyClaim,
        delete: this.actions.updateSelectedAction,
        pushxml: this.actions.updateSelectedAction,
        reconcile: this.actions.updateSelectedAction,
        unreconcile: this.actions.updateSelectedAction,
        unsubmit: this.actions.updateSelectedAction
    });

    const actionMethod = confirmationModalMap(action, this.actions.resetConfirmationModal, onConfirmActions);

    actionMethod ?
        this.actions.setConfirmationModal(actionMethod) :
        this.actions.updateSelectedAction(action);

}

function readClaimIfEdit() {

    if (this.props.routeParams.claimNumber && !this.props.queryParams.action) {

        this.props.actions.readAttachmentClaim(this.props.routeParams.claimNumber);
        this.props.actions.updateIsEditable(false);

    }

}

function handleClaimAction() {

    if (this.props.queryParams.action) {

        const action = new ClaimAction({
            actionName: this.props.queryParams.action,
            id: this.props.queryParams.action,
            mode: ''
        });

        this.props.actions.readAttachmentClaim(this.props.routeParams.claimNumber, action);

        if (['DIS_VSR', 'RECONCILE', 'UNRECONCIL', 'DEL', 'REQ_ADDL', 'UNSUB', 'PUSH_XML'].includes(this.props.queryParams.action)) {

            this.props.actions.updateIsEditable(false);

        }

    }

}

function handleCreateClaimModalClose() {

    this.actions.updateCreateClaimModalVisibility(false);

}

function handleClick(key, pin) {

    if (this.createClaimModal.mode === 'CREATE') {

        this.actions.onCreateClaim(key, pin, this.claim.claimType.key);

    }

    if (this.createClaimModal.mode === 'EDIT') {

        this.actions.onEditClaim(key, pin, this.claim.claimType.key, this.claim);

    }

}

function openCreateClaimModal() {

    this.actions.updateCreateClaimModalVisibility(true);
    this.actions.updateClaimModalMode('EDIT');

}

class AttachmentClaims extends Component {

    componentWillMount() {

        this.props.actions.updateTemporaryObjectKey(generateTemporaryObjectKey());
        this.props.actions.readOwnershipStatuses();
        this.props.actions.readDownTime();
        this.props.actions.readFailureModes();
        this.props.actions.readOtherCreditDescriptions('ZZNS');
        this.props.actions.readClaimTypes();
        this.props.actions.readGoodsInstallationVatOptions();

        this::readClaimIfEdit();
        this::handleClaimAction();

    }

    componentDidUpdate() {

        if (this.props.isCopied) {

            const tempObjectKey = generateTemporaryObjectKey();

            this.props.actions.updateTemporaryObjectKey(tempObjectKey);
            this.props.actions.copyAttachments(this.props.claim, tempObjectKey, 'ATTACHMENT');

        }

    }

    componentWillUnmount() {

        this.props.actions.resetAttachmentClaim();

    }

    render() {

        return (
            <section className='attachment-claims'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <WarrantyStickyNode
                    activeClass='enabled'
                    innerZ={4}
                    top='.app-header'
                >
                    <ClaimStickyHeader
                        allowedActions={this.props.claim.allowedActions}
                        claimNumber={formatClaimNumber(this.props.claim.claimNumber)}
                        claimStatus={this.props.claim.claimStatus.key}
                        creditMemoNumber={this.props.claim.claimValueDetails.creditMemoNumber}
                        errorMessages={this.props.claim.vsrErrorMessages()}
                        infoMessages={this.props.claim.vsrInfoMessages()}
                        isActionButtonDisabled={this.props.isActionButtonDisabled}
                        isEditable={this.props.isEditable}
                        onActionClick={this.props::handleActionClick}
                        warningMessages={this.props.claim.vsrWarningMessages()}
                    />
                </WarrantyStickyNode>
                <div className='attachment-claim-details'>
                    <main>
                        <div className='create-claim-details'>
                            <LabeledNode
                                className='claim-type'
                                data={
                                    this.props.routeParams.claimNumber ?
                                        <span>{this.props.claim.claimType.value}</span> :
                                        <ActionLink
                                            isDisabled={false}
                                            label={translate('ATTACHMENTS')}
                                            onClick={this.props::openCreateClaimModal}
                                            type='button-link'
                                        />
                                }
                                label='CLAIM_TYPE'
                            />
                            <LabeledString
                                className='claim-status'
                                data={this.props.claim.claimStatus.value}
                                label='STATUS'
                            />
                            <LabeledString
                                className='created-date'
                                data={buildDate(this.props.claim.recordInfo.createdDate)}
                                label='CREATED'
                            />
                            <LabeledString
                                className='modified-date'
                                data={buildDate(this.props.claim.recordInfo.updatedDate)}
                                label='MODIFIED'
                            />
                        </div>
                        <ClaimDetails/>
                        <FailurePanel/>
                        {!this.props.claim.showValidate &&
                            <div className='claim-items'>
                                <PartsPanel
                                    actions={this.props.actions}
                                    errors={this.props.claim.errors}
                                    isEditable={this.props.isEditable}
                                    parts={this.props.claim.parts}
                                    partsGroupedByPartNumber={this.props.partsGroupedByPartNumber}
                                    showPartInvoiceNumber={this.props.claim.rules.showPartInvoiceNumber}
                                />
                                <LaborsPanel/>
                                <OtherCreditsPanel/>
                                {!this.props.claim.hideClaimValueDetails &&
                                    <ClaimValue
                                        allowedActions={this.props.claim.allowedActions}
                                        claimNumber={this.props.claim.claimNumber}
                                        claimStatus={this.props.claim.claimStatus.key}
                                        claimValueDetails={this.props.claim.claimValueDetails}
                                        showAmountsInLocalCurrency={false}
                                    />
                                }
                            </div>
                        }
                    </main>
                    <aside>
                        {this.props.claim.reimbursementDetails.totalApproved > 0 &&
                            <ClaimValueSummary
                                allowedActions={this.props.claim.allowedActions}
                                claimNumber={this.props.claim.claimNumber}
                                claimStatus={this.props.claim.claimStatus.key}
                                claimValueDetails={this.props.claim.claimValueDetails}
                                className='claim-value-summary'
                                reimbursementDetails={this.props.claim.reimbursementDetails}
                            />
                        }
                        <FileAttachmentPanel
                            files={this.props.claim.file}
                            onFileDelete={this.props::handleFileDelete}
                            onFileUploadSuccess={this.props::handleFileUploadSuccess}
                            serviceConfig={getTempAttachmentServiceConfig(this.props.claim.claimNumber, this.props.temporaryObjectKey)}
                        />
                    </aside>
                </div>
                <ConfirmationModal
                    confirmMessage={this.props.confirmationModal.confirmMessage}
                    isOpen={this.props.confirmationModal.isOpen}
                    onClose={this.props.confirmationModal.onClose}
                    onConfirm={this.props.confirmationModal.onConfirm}
                    title={this.props.confirmationModal.title}
                />
                <CreateClaimModal
                    claimTypes={this.props.createClaimModal.claimTypes}
                    isModalOpen={this.props.createClaimModal.isModalOpen}
                    onClick={this.props::handleClick}
                    onCloseButtonClick={this.props::handleCreateClaimModalClose}
                />
            </section>
        );

    }

}

AttachmentClaims.displayName = 'AttachmentClaims';
AttachmentClaims.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    claim: PropTypes.instanceOf(AttachmentClaim).isRequired,
    confirmationModal: PropTypes.instanceOf(ConfirmationModalState).isRequired,
    createClaimModal: PropTypes.instanceOf(CreateClaimModalType).isRequired,
    isActionButtonDisabled: PropTypes.bool.isRequired,
    isCopied: PropTypes.bool.isRequired,
    isEditable: PropTypes.bool.isRequired,
    partsGroupedByPartNumber: PropTypes.object.isRequired,
    routeParams: PropTypes.object.isRequired,
    temporaryObjectKey: PropTypes.string
};

export default AttachmentClaims;



// WEBPACK FOOTER //
// ./src/claim/attachment/components/index.js